
import { Component, Vue } from "vue-property-decorator";
import ServicesNav from "@/components/Main/Services/ServicesNav.vue";
import ServicesBanner from "@/components/Main/Services/ServicesBanner.vue"
// import PublicPromocode from "@/components/Main/Services/PublicPromocode.vue";
import ServiceOS from "@/components/Main/Services/ServiceOS.vue";
import DexSafeModal from "@/components/Main/Services/Modals/DexSafeModal.vue" 
@Component({
  components: {
    ServicesNav,
    ServicesBanner,
    ServiceOS,
    // PublicPromocode,
    DexSafeModal
  },
})
export default class DexSafe extends Vue {
  public isShowModal: boolean  = false;

  // methods
  public handleShowModal() {
    this.isShowModal = true
  }

  public handleCloseDexSafeModal() {
    this.isShowModal = false
  }
}
